<template>
    <div>
        <div class="ItemModalContainer">
            <button @click="insertRecord" class="openModalButton" v-html="buttonHtml"></button>
            <div v-if="modalActive" class="modal" @click.self="hideModal">
                <div class="modalForm" >
                    <h2 class="modalTitle">{{modalActionText}} Shared Detail</h2>
                    <div class="formRow inputTitle">* Description</div>
                    <div>
                        <textarea  v-model="item.description" style="width:90%"></textarea>
                    </div>
                    <div class="formRow inputTitle">Languages: {{ item.languages.join(', ') }}</div>
                    <div class="formRow inputTitle">* Display Text</div>
                    <div>            
                        <DisplayText :displayText="getDisplayText" :showLabel="false"  :onChanged="saveDisplayText"
                            :object="item" :disabled="false" textPropertyName="displayText" width="90%"></displayText> 
                    </div>
                    <div>
                        <TranslatedText v-if="item.displayText && item.languages.length > 1"
                            :textJson="item.displayTextJson"></TranslatedText>
                    </div>
                    <div class="formRow inputTitle">Tool Tip</div>
                    <div>
                        <select v-if="toolTips" v-model="item.mediaPropertyID" >
                            <option value=""></option>
                            <option v-for="mp in toolTips" :key="mp.id" :value="mp.id">{{ mp.description }}</option>
                        </select>
                    </div>
                    <div class="formRow inputTitle">Tags</div>
                    <div>
                        <VueMultiselect v-model="item.tags" :multiple="true"  :close-on-select="false" :options="tags" :taggable="true" @tag="addTag" @remove="removeTag" >
                            <template #noResult>No elements found.</template>
                        </VueMultiselect>
                    </div>
                    <div class="formRow">*Required</div>
                    <div class="formRow">
                        <button @click="hideModal" class="cancelButton">Cancel</button>
                        <button @click="saveItem" class="saveButton">Save Shared Detail</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import {translation} from '../../shared/translation';
import DisplayText from '@/components/shared/DisplayText.vue';
import VueMultiselect from 'vue-multiselect';
import TranslatedText from '@/components/shared/TranslatedText.vue';

export default {
    name: 'ItemModal',
    components: { DisplayText, VueMultiselect, TranslatedText },
    props: {
        inputValues: {
            type: Object
        },
        refreshItemsFunction: {
            type: Function
        },
        newTagType: {
            type: String
        },
        buttonHtml: {
            type: String,
            default: '<i class="fa-circle-plus fas fa-2xl"></i>'
        }
    },
    data: function() {
        return {
            modalActive: false,
            item: {
                languages: ["English"],
                defaultLanguage: 'English',
                displayTextJson: [{language:'English', text:''}]
            },
            tags: null,
            newTags: [],
            toolTips: null
        }
    },
    async mounted() {
        var tags = await data.getTags("", "AccordionDetail", true);
        this.tags = tags.map( obj => { return obj.name});
        this.sortTags();

        var mediaProperties = await data.getMediaPropertiesByMediaType('ToolTip');
        mediaProperties.sort(this.compareValues('description'));
        this.toolTips = mediaProperties;
        document.addEventListener("keydown", (e) => {
            if(!this.modalActive) return;
            if (e.key == 'Enter') {
                // Don't submit if Enter is pressed in a textarea or in the multiselect
                if(document.activeElement.tagName.toLowerCase() !== 'textarea' && Array.from(document.activeElement.classList).indexOf('multiselect__input') < 0)
                    this.saveItem();
            }
            if (e.key == 'Escape')
                this.hideModal();
        });
    },
    computed: {
        modalActionText () {
            if(this.item.id)
                return "Edit";
            else
                return "Create New";
        },
        getDisplayText() {
            return translation.getTextForLanguage(this.item.displayTextJson, this.item.defaultLanguage);
        }
    },
    methods: {
        compareValues: function(key, order = 'asc') {
            return function innerSort(a, b) {
                const varA = (typeof a[key] === 'string')
                    ? a[key].toUpperCase() : a[key];
                const varB = (typeof b[key] === 'string')
                    ? b[key].toUpperCase() : b[key];

                let comparison = 0;
                if (varA > varB) {
                    comparison = 1;
                } 
                else if (varA < varB) {
                    comparison = -1;
                }

                return ( (order === 'desc') ? (comparison * -1) : comparison );
            };
        },
        sortTags: function() {
            this.tags.sort();
        },
        addTag: function(newTag) {
            newTag = newTag.toUpperCase();
            this.tags.push(newTag);
            this.newTags.push(newTag);
            if(!this.item.tags)
                this.item.tags = [];
            this.item.tags.push(newTag);
            this.sortTags();
        },
        removeTag: function(removeTag) {
            var index = this.newTags.indexOf(removeTag);
            if(index >= 0) {
                this.newTags.splice(index, 1);
                index = this.tags.indexOf(removeTag);
                if(index >=0)
                    this.tags.splice(index, 1);
            }
        },
        editRecord: function(values) {
            this.item = values;      
            this.showModal();
        },
        insertRecord: function() {
            this.inputData = {};
            this.showModal();
        },
        showModal: function() {
            this.modalActive = true;
        },
        hideModal: function() {
            this.modalActive = false;
            this.emptyItem();
        },
        saveItem: async function() {
            var NewTag = {}
            NewTag.tagType = this.newTagType;
            NewTag.isActive = true;

            for(var i = 0; i < this.newTags.length; i++) {
                NewTag.name = this.newTags[i];
                NewTag.description = this.newTags[i];
                var tagReturn = await data.saveTag(NewTag);

                if(!tagReturn.success) {
                    this.$toast.error("Could not add tag: " + NewTag.name + "<br />" 
                        + tagReturn.errors.join("<br />"));
                    return;
                }
            }

            this.newTags = [];
            var retObject = this.processSaveResult(await data.saveSharedDetail(this.item));

            if(retObject.success) {
                this.componentKey++;

                if(retObject.id)
                    this.item.id = retObject.id;

                this.hideModal();
                this.refreshItemsFunction();

            }
        },
        emptyItem: function() {
            this.item = {
                languages: ["English"],
                defaultLanguage: 'English',
                displayTextJson: [{language:'English', text:''}]
            };
        },
        saveDisplayText: async function(item, newValue) {
            item.displayText = newValue;
            item.displayTextJson = await translation.addTranslations(item.displayTextJson, item.displayText, item.languages, item.defaultLanguage)
        },
        getAccordions: async function() {
            return await data.getAllAccordions('', false, 0, this.item.id);
        }
    }
}
</script>

<style scoped src="@/assets/css/shared/itemModal.css"></style>
<style scoped>
</style>